import BrbBtn from './brb-components/BrbBtn.vue'
import BrbInput from './brb-components/BrbInput.vue'
import BrbSelect from './brb-components/BrbSelect.vue'
import BrbSwitch from './brb-components/BrbSwitch.vue'
import BrbCheckbox from './brb-components/BrbCheckbox.vue'
import BrbDateTimePicker from './brb-components/BrbDateTimePickerNew.vue'
import BrbDateTimeDisplay from './brb-components/BrbDateTimeDisplay.vue'
import BrbLabelValue from './brb-components/BrbLabelValue.vue'
import BrbModal from './brb-components/BrbModal.vue'
import BrbCard from './brb-components/BrbCard.vue'
import BrbMedia from './brb-components/BrbMedia.vue'
import BrbImagePreview from './brb-components/BrbImagePreview.vue'
import BrbUploader from './brb-components/BrbUploader.vue'
import BrbFormWrapper from './brb-components/BrbFormWrapper.vue'
import BrbSelectableItem from './brb-components/BrbSelectableItem.vue'

export default {
  BrbBtn,
  BrbInput,
  BrbSelect,
  BrbSwitch,
  BrbCheckbox,
  BrbDateTimePicker,
  BrbDateTimeDisplay,
  BrbLabelValue,
  BrbModal,
  BrbCard,
  BrbMedia,
  BrbImagePreview,
  BrbUploader,
  BrbFormWrapper,
  BrbSelectableItem
}
